import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.slack.SlackConnectForm', {
    title: 'ApprovalMax application for Slack would like to access your data.',
    description: 'Please confirm you wish to grant access to your ApprovalMax account:',
    buttonAllow: 'Allow access',
    buttonCancel: 'Cancel and go back',
    optionWatchAll: 'Watch all organisations',
    optionWatchSelected: 'Watch selected organisation(s)',
    errorWatchType: 'Unsupported field value.',
    errorSelectedCompaniesWrongValue: 'Wrong values type.',
    errorSelectedCompaniesNotEmpty: 'Organisations should not be selected.',
    errorSelectedCompaniesEmpty: 'At least one organisation should be selected.',
});
